import { isEmpty } from 'lodash'

export default {
  refresh() {
    return new Promise(resolve => {
      if (this.$store.getters['binaries/list'].length === 0) {
        resolve()
      }
      this.updateDisplayStyle()
        .then(() => {
          return this.setDisplayStyleOptions()
        })
        .then(resolve)
    })
  },
  updateDisplayStyle() {
    return new Promise(resolve => {
      /**
       * Called if submission was mutated in $store.
       * Resets the displayStyle value in the view.
       */
      const id = this.displaystyle.values?.value
      if (typeof id === 'string') {
        const result = this.submissionBinaries.filter(b => b.binaryId === id)[0]
        if (typeof result === 'object') {
          this.displaystyle.setValues({
            obj: {
              name: result.styleName,
              id: result.binaryId
            },
            value: 'id',
            name: 'name'
          })
        }
      }
      /**
       * Done.
       */
      resolve()
    })
  },
  setDisplayStyle() {
    this.setDisplayStyleValues()
    this.setDisplayStyleOptions()
  },
  setDisplayStyleOptions() {
    return new Promise(resolve => {
      /**
       * Transform userMetaData from Submission in displayStyle options.
       * If it has options, then sort style names by font style.
       * If displayStyle has no value or
       * if value does not exist (anymore, i.e. deleted) in options,
       * then set first option for display value.
       */
      const options = []
      for (const result of this.submissionBinaries) {
        if (result?.styleName?.length > 0) {
          options.push({
            label: result.styleName,
            value: result.binaryId
          })
        }
      }
      if (options.length > 0) {
        const isValueInOptions =
          typeof this.displaystyle.values?.value === 'string'
            ? options.some(o => o.value === this.displaystyle.values.value)
            : false
        if (this.displaystyle.values === null || !isValueInOptions) {
          this.displaystyle.setValues({
            obj: [options[0]],
            value: 'value',
            name: 'label'
          })
          this.submissionDefaultLayoutFont = this.displaystyle.getApiValues({
            value: 'id',
            name: 'name'
          })
        }
        else if (this.displaystyle.values.value.id !== this.submissionDefaultLayoutFont.id) {
          this.submissionDefaultLayoutFont = this.displaystyle.getApiValues({
            value: 'id',
            name: 'name'
          })
        }
      }
      this.displaystyle.options = options
      /**
       * Done.
       */
      resolve()
    })
  },
  setDisplayStyleValues() {
    /**
     * Pull style values from submission.
     */
    this.displaystyle.setValues({
      obj: this.submissionDefaultLayoutFont,
      value: 'id',
      name: 'name'
    })
  },
  updateDisplayStyleValues(val) {
    /**
     * Updates the displayStyle in submission.
     */
    let selectedStyleValue = val
    if (isEmpty(selectedStyleValue)) {
      selectedStyleValue = this.displaystyle.options.find(option => option.label === this.binariesList[0].styleName)
    }
    this.displaystyle.state = 'set'
    this.displaystyle.update(selectedStyleValue, this.commitChange)
  },
  commitChange() {
    /**
     * Translate fou-select values into api values for submission update.
     */
    this.submissionDefaultLayoutFont = this.displaystyle.getApiValues({
      value: 'id',
      name: 'name'
    })
    this.updateSubmission()
  }
}
